import { render, staticRenderFns } from "./Effects.vue?vue&type=template&id=3d8ee096&scoped=true"
import script from "./Effects.vue?vue&type=script&lang=js"
export * from "./Effects.vue?vue&type=script&lang=js"
import style0 from "./Effects.vue?vue&type=style&index=0&id=3d8ee096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8ee096",
  null
  
)

export default component.exports